// extracted by mini-css-extract-plugin
export default {"wrapper":"contact-detail_wrapper__JqSZa","item":"contact-detail_item__Zhcwd","itemValue":"contact-detail_itemValue__reMOe","itemLabel":"contact-detail_itemLabel__RdMSG"};